/**
 * iOS-inspired color palette
 * Used across the admin dashboard for consistent styling
 */
export const iosColors = {
  // Backgrounds
  background: '#F2F2F7',   // 5-digit '#FFFFF' was invalid → CSS ignored it → white
  cardBg: '#FFFFFF',
  inputBg: '#F7F7F8',
  sectionBg: '#F7F7F8',
  lightGray: '#F2F2F7',

  // Borders
  border: '#E5E5EA',

  // Text
  text: '#1C1C1E',
  textMuted: '#8E8E93',
  gray: '#8E8E93',

  // Hostea brand (website primary — used for premium accents like calendar pills)
  brandBlue: '#2569C9',
  brandBlueHover: '#1E5AB5',

  // Primary colors
  blue: '#007AFF',
  green: '#34C759',
  orange: '#FF9500',
  red: '#FF3B30',
  purple: '#AF52DE',
  yellow: '#FFCC00',
  teal: '#5AC8FA',
  pink: '#FF2D55',
  indigo: '#5856D6',
  mint: '#00C7BE',
};

export default iosColors;
